<ng-container *ngFor="let key of goalsKeys">
  <div
    *ngIf="!!log && hasLog(key, log)"
    [innerHTML]="normalizeLog(key, log) | changeLogsDiffHTML: goalsLookup : null"
  ></div>
</ng-container>
